import React from "react";
import { Box, Typography, useTheme } from "@mui/material";

const Footer: React.FC = () => {
  const theme = useTheme();
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        width: "100%",
        py: 2.5,
        textAlign: "center",
        backgroundColor:
          theme.palette.mode === "dark"
            ? "background.paper"
            : theme.palette.grey[100],
        color: "text.secondary",
        borderTop: `1px solid ${theme.palette.divider}`,
        mt: "auto",
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        © {year} Fiji Platforms Inc. All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
